import { isString } from 'lodash-es';

const TYPE_ERROR = 'The constructor requires a string value';

export class SimplifiedRegex {
  private readonly ESCAPE_REGEX = /[-{}[\]+?.,\\^$|#]/g;
  private readonly ESCAPE_REGEX_REPLACE = '\\$&';

  private readonly OPTIONAL_PARAM = /\s*\((.*?)\)\s*/g;
  private readonly OPTIONAL_PARAM_REPLACE = '(?:$1)?';

  private readonly NAMED_PARAM = /(\(\?)?:\w+/g;
  private readonly NAMED_PARAM_REPLACE = '([^\\s]+)';

  private readonly SPLAT_PARAM = /\*\w+/g;
  private readonly SPLAT_PARAM_REPLACE = '(.*?)';

  private readonly OPTIONAL_REGEX = /(\(\?:[^)]+\))\?/g;
  private readonly OPTIONAL_REGEX_REPLACE = '\\s*$1?\\s*';
  private regex: string;

  constructor(regex: string) {
    if (!isString(regex)) {
      throw new TypeError(TYPE_ERROR);
    }
    this.regex = regex;
  }

  public toRegex(): RegExp {
    const command = this.regex
      .replace(this.ESCAPE_REGEX, this.ESCAPE_REGEX_REPLACE)
      .replace(this.OPTIONAL_PARAM, this.OPTIONAL_PARAM_REPLACE)
      .replace(this.NAMED_PARAM, (match, optional) =>
        optional ? match : this.NAMED_PARAM_REPLACE
      )
      .replace(this.SPLAT_PARAM, this.SPLAT_PARAM_REPLACE)
      .replace(this.OPTIONAL_REGEX, this.OPTIONAL_REGEX_REPLACE);
    return new RegExp('^' + command + '$', 'i');
  }
}
